import angular from 'angular';
import onboardingUsersQuestionniare from './onboardingUsersQuestionniare';
import './style.scss';

export default angular
  .module('components.onboardingUsersQuestionniare', [])
  .component('onboardingUsersQuestionniare', onboardingUsersQuestionniare).name;
